





































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { getAllStates, getCounties, getZips } from '@/api/fipLists'
import { FipStateModule } from '@/store/modules/fipStates'
import { FipCountyModule } from '@/store/modules/fipCounties'
import { FipZipModule } from '@/store/modules/fipZips'
import { IStateListItem, ICountyListItem, IZipListItem } from '@/api/types-fip'
import { IVendorCoverage } from '@/api/types-vendor'
import { isArray } from '@/utils/validate'

@Component({
  name: 'FipStateOptions'
})
export default class extends Vue {
  @Prop({ required: true }) private value!: IVendorCoverage
  @Prop({ required: true, default: 0 }) vendorId!: number
  private stateOptions: IStateListItem[] = []
  private countyOptions: ICountyListItem[] = []
  private zipOptions: IZipListItem[] = []
  selectedZips: IZipListItem[] = []

  get getVendorId() {
    return this.vendorId
  }

  mounted() {
    this.$nextTick(() => {
      this.fetchData()
    })
  }

  async updateZip(item: IZipListItem[]) {
    if (item == null) {
      this.value.zipList = []
    } else if (isArray(item)) {
      this.value.zipList = []
      item.forEach(element => {
        this.value.zipList.push(element)
      })
    }
  }

  async updateCounty(item: ICountyListItem) {
    if (item == null) {
      FipZipModule.clearList()
      this.value.postalCode = ''
      this.value.countyFips = ''
      this.value.county = ''
      this.value.zipList = []
      this.zipOptions = []
    } else {
      let list = FipZipModule.FipZipList || []
      if (list.length === 0 || !(FipZipModule.stateFips === item.fipsState && FipZipModule.countyFips === item.fipsCounty)) {
        console.info(`Fetching ZIP List for County ${item.countyName}. ${list.length}`)
        const { data } = await getZips(this.getVendorId, item.fipsState, item.fipsCounty)
        FipZipModule.loadFipZips(item.fipsState, item.fipsCounty, data)
        list = data
      }
      this.zipOptions = list
      this.value.countyFips = `${item.fipsCounty}`
      this.value.county = item.countyName
    }
  }

  async updateState(item: IStateListItem) {
    if (item == null) {
      FipCountyModule.clearList()
      this.value.stateFips = '0'
      this.value.state = ''
      this.value.zipList = []
      this.countyOptions = []
    } else {
      let list = FipCountyModule.FipCountyList || []
      if (list.length === 0 || FipCountyModule.stateFips !== item.fipsState) {
        console.info(`Fetching Fip County List for State ${item.stateAbbrv}. ${list.length}`)
        const { data } = await getCounties(item.fipsState)
        FipCountyModule.loadFipCounties(item.fipsState, data)
        list = data // FipCountyModule.cachedFipCounties
      }
      this.value.stateFips = `${item.fipsState}`
      this.value.state = item.stateAbbrv
      this.countyOptions = list
    }
  }

  private async fetchData() {
    let list = FipStateModule.FipStateList
    // clear out any selected items.
    this.value.zipList = []
    if (list.length === 0) {
      console.info(`Fetching Fip State List. ${list.length}`)
      const { data } = await getAllStates()
      FipStateModule.loadFipStates(data)
      list = data // FipStateModule.cachedFipStates
    }
    this.stateOptions = list
  }
}
